import { noop } from 'lodash';
import React from 'react';
import { IChatBubbleContext } from 'types/devRev';

const ChatBubbleContext = React.createContext<IChatBubbleContext>({
	shouldOpen: false,
	open: noop,
	close: noop
});

export default ChatBubbleContext;
